import React from 'react';
import { motion } from 'framer-motion';
import { FileText, ExternalLink, Calendar } from 'lucide-react';
import { articles } from '../data/siteData';

const Articles = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  const hasArticles = articles && articles.length > 0;

  return (
    <section id="articles" className="articles-section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h1>Selected Articles & Technical Writing</h1>
          <p>Technical publications and engineering insights</p>
        </motion.div>

        {hasArticles ? (
          <motion.div
            className="articles-grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {articles.map((article) => (
              <motion.a
                key={article.id}
                href={article.url}
                target="_blank"
                rel="noopener noreferrer"
                className="article-card"
                variants={itemVariants}
                whileHover={{ y: -5 }}
              >
                <div className="article-icon">
                  <FileText size={24} />
                </div>
                <div className="article-content">
                  <h2>{article.title}</h2>
                  {article.publication && (
                    <span className="article-publication">{article.publication}</span>
                  )}
                  <p>{article.summary}</p>
                  <div className="article-meta">
                    <span className="article-date">
                      <Calendar size={14} />
                      {article.date}
                    </span>
                    <span className="article-link">
                      Read More <ExternalLink size={14} />
                    </span>
                  </div>
                </div>
              </motion.a>
            ))}
          </motion.div>
        ) : (
          <motion.div
            className="empty-state"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <FileText size={48} className="empty-state-icon" />
            <p className="empty-state-text">Articles coming soon</p>
            <p className="empty-state-subtext">Technical writing and research publications will appear here.</p>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default Articles;
